import {Authenticated} from './middleware'

export default [

  {
    name: 'serviceMenu',
    path: '/',
    redirect: {name: 'serviceMenu.statistic'},
    component: () => import ('../../views/serviceMenu/index'),
    meta: {
      title: 'Сервисное меню',
      back: 'cpanel.dashboard',
      middleware: Authenticated
    },
    children: [

      {
        name: 'serviceMenu.statistic',
        path: 'statistic',
        component: () => import ('../../views/serviceMenu/Statistic'),
        meta: {
          title: 'Сервисное меню',
          back: 'cpanel.dashboard',
          middleware: Authenticated,
          permission: 'can.manage.users'
        }
      }
    ]
  },


];

